module.exports = __webpack_public_path__ + "static/media/bg_blue.728edef1.png";